import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./../styles/register.css";
import { ClipLoader } from "react-spinners";
import { register } from "../api/auth.api";
import { useUser } from "../context/UserContext";
import { IoEye } from "react-icons/io5";
import { IoEyeOff } from "react-icons/io5";
import ToastNotification, { showTopCenterToast } from "../components/toasts/ToastNotification";

const Register = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  const { user } = useUser();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isDisplay, setIsDisplay] = useState(false);

  useEffect(() => {
    if (user) navigate("/");
    document.title = "Đăng ký";
  }, []);

  const handleRegister = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      setError(null);

      if (
        username === " " ||
        email === " " ||
        password === " " ||
        confirmPassword === " "
      ) {
        setLoading(false);
        showTopCenterToast("Vui lòng điền vào các trường", "error");
        return;
      }

      await register(username, email, password);

      setLoading(false);
      navigate("/login?reg=true");
    } catch (error) {
      setLoading(false);
      showTopCenterToast(error.message, "error");
    }
  };

  return (
    <div className="register-container">
      <ToastNotification />
      <div className="register-box">
        <h2 className="register-title">Đăng ký</h2>
        {/* <p className="register-second-title">
          Tham gia ngay – Nhận ưu đãi liền tay!
        </p> */}

        {error && <p className="error-text">*{error.message}</p>}
        <form onSubmit={handleRegister}>
          <div className="input-group">
            <input
              type="text"
              placeholder="Tên đăng nhập"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="reg-input"
            />
          </div>
          <div className="input-group">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="reg-input"
            />
          </div>
          <div className="input-group">
            <div className="password-input-container">
              <input
                type={`${isDisplay ? "text" : "password"}`}
                placeholder="Mật khẩu"
                value={password}
                onChange={(e) => setPassword(e.target.value.trim())}
                required
                className="reg-input"
              />
              {!isDisplay ?
                <IoEye onClick={() => setIsDisplay(!isDisplay)} className="eye-pw-icon" />
                :
                <IoEyeOff onClick={() => setIsDisplay(!isDisplay)} className="eye-pw-icon" />}
            </div>
          </div>
          <div className="input-group">
            <input
              type={`${isDisplay ? "text" : "password"}`}
              placeholder="Xác nhận mật khẩu"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="reg-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={
              loading ? "disabled-btn register-button" : "register-button"
            }
          >
            {loading ? (
              <ClipLoader size={20} color="#fff" />
            ) : (
              <p className="submit-text">Đăng ký</p>
            )}
          </button>
        </form>

        <p className="login-text">
          Bạn đã có tài khoản? <a href="/login">Đăng nhập ngay</a>
        </p>
        <a className="back-to-dashboard-button" href="/">
          ← Quay về trang chủ
        </a>
      </div>
    </div>
  );
};

export default Register;
